export default "__VITE_ASSET__BnFB4hBU__"